import { useCreateFloorMutation } from 'src/api/v2/floor-v2-ApiSlice';
import { useAppDispatch } from 'src/app/hooks';
import { plannerUiSlice } from 'src/api/planner-ui-slice';
import { showSnackBar } from 'src/api/ui-slice';
import { ts } from 'src/utils/translate';

export enum RoomCreationMethod {
    MANUAL = 'MANUAL',
    AUTOMATIC = 'AUTOMATIC',
}

export enum FloorLayout {
    UPLOAD = 'UPLOAD',
    SAMPLE = 'SAMPLE',
}

export interface FloorFormData {
    selectedLayout: FloorLayout;
    floorId?: number;
    floorName: string;
    ceilingHeight: string;
    dontShowAgain: boolean;
    planImageFile: File | null;
    planPreviewImageUrl: string | null;
    planPdfFile: File | null;
    planPdfPage: number;
    roomCreationMethod?: RoomCreationMethod;
}

export const isFloorUploadStepValid = (formData: FloorFormData): boolean =>
    !!formData.ceilingHeight &&
    (formData.selectedLayout !== FloorLayout.UPLOAD || formData.planPreviewImageUrl != null);

export const useUpsertFloor = (projectId: number, onClose: () => void) => {
    const [createFloor] = useCreateFloorMutation();
    const dispatch = useAppDispatch();

    const upsertFloor = (formData: FloorFormData): Promise<number | null> =>
        createFloor({
            floorId: formData.floorId,
            projectId,
            floorName: formData.floorName,
            headroom: formData.ceilingHeight,
            lengthProportion: '1',
            planImage: formData.planImageFile ?? undefined,
        })
            .unwrap()
            .then((data) => data.id)
            .catch(() => {
                dispatch(showSnackBar({ text: ts('create_floor_error', 'Failed to save floor'), severity: 'error' }));
                return null;
            });

    const startScaleSetup = (floorId: number) => {
        dispatch(plannerUiSlice.actions.setSelectedFloorId(floorId));
        dispatch(plannerUiSlice.actions.setPendingScaleSetupFloorId(floorId));
        onClose();
    };

    return { upsertFloor, startScaleSetup };
};